// extracted by mini-css-extract-plugin
export default {"back-to-top":"BackToTopButton_back-to-top__3xDs0","fadeIn":"BackToTopButton_fadeIn__hGsbB"};